import React from 'react';

const ManageConsultantConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes: [
        {
            path: '/upload/manageconsultant',
            component: React.lazy(() => import('./Manageconsultant.js'))
        }
    ]
};

export default ManageConsultantConfig;